import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListMetricsQuery, useGetAccountQuery, useChangeHiddenKpiSettingsMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeHiddenKpiSettings',
  props: {
    portfolioId: {
      type: String,
      required: true
    },
    useButton: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useListMetricsQuery = useListMetricsQuery(function () {
        return {
          input: {
            portfolioCanEditMetricValue: true,
            relevantToPortfolioId: props.portfolioId
          }
        };
      }),
      result = _useListMetricsQuery.result,
      loading = _useListMetricsQuery.loading;
    var metrics = computed(function () {
      var _result$value$listMet, _result$value;
      return (_result$value$listMet = result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listMetrics) !== null && _result$value$listMet !== void 0 ? _result$value$listMet : [];
    });
    var _useGetAccountQuery = useGetAccountQuery(),
      aResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _aResult$value$getAcc, _aResult$value;
      return (_aResult$value$getAcc = aResult === null || aResult === void 0 ? void 0 : (_aResult$value = aResult.value) === null || _aResult$value === void 0 ? void 0 : _aResult$value.getAccount) !== null && _aResult$value$getAcc !== void 0 ? _aResult$value$getAcc : {
        hiddenKpis: []
      };
    });
    var _useChangeHiddenKpiSe = useChangeHiddenKpiSettingsMutation(),
      mutate = _useChangeHiddenKpiSe.mutate,
      onError = _useChangeHiddenKpiSe.onError;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var selectedMetricIds = ref([]);
    var isSaving = ref(false);
    var saveError = ref('');
    onError(function (err) {
      var _err$message;
      saveError.value = (_err$message = err.message) !== null && _err$message !== void 0 ? _err$message : String(err);
    });
    var syncSelectedMetricIds = function syncSelectedMetricIds() {
      var _account$value$hidden, _account$value;
      var availableIds = new Set(metrics.value.map(function (metric) {
        return metric.id;
      }).filter(function (id) {
        return id != null;
      }));
      selectedMetricIds.value = ((_account$value$hidden = (_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.hiddenKpis) !== null && _account$value$hidden !== void 0 ? _account$value$hidden : []).filter(function (id) {
        return availableIds.has(id);
      });
    };
    var handleSelectionChange = function handleSelectionChange(selected) {
      selectedMetricIds.value = selected;
    };
    var handleSave = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(toggleDialog) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isSaving.value = true;
              saveError.value = '';
              _context.prev = 2;
              _context.next = 5;
              return mutate({
                portfolioId: props.portfolioId,
                hiddenKpis: selectedMetricIds.value
              });
            case 5:
              toggleDialog();
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              if (!saveError.value) {
                saveError.value = String($i18n.t('saveError'));
              }
            case 11:
              _context.prev = 11;
              isSaving.value = false;
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 8, 11, 14]]);
      }));
      return function handleSave(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    watch([metrics, function () {
      var _account$value2;
      return (_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.hiddenKpis;
    }], syncSelectedMetricIds, {
      immediate: true
    });
    return {
      __sfc: true,
      props: props,
      result: result,
      loading: loading,
      metrics: metrics,
      aResult: aResult,
      account: account,
      mutate: mutate,
      onError: onError,
      $i18n: $i18n,
      selectedMetricIds: selectedMetricIds,
      isSaving: isSaving,
      saveError: saveError,
      syncSelectedMetricIds: syncSelectedMetricIds,
      handleSelectionChange: handleSelectionChange,
      handleSave: handleSave
    };
  }
});